export default class Global {
  static robotInfo: {
    robotCode: any;
  } = {
    robotCode: undefined,
  };

  static fetchHeader: any = {};

  static jumpTo = function (href: string, key?: any, path?: any, value?: any) {};

  static queryBill = function () {};

  static customerCodeCz = function () {};

  static provinceAndCity = {};

  static components = {};
}
